import React, { useEffect, useState } from "react";
import { Spinner } from "reactstrap";
import moment from "moment";

import { AUTOPILOT_COLORS } from "../../../components/autopilot/styles";
import { mensagemErroPedido, obterDetalhe } from "../../../services/pedidosApi";

// Linha aberta do pedido (H2, PO1-2376): quando o pedido já tem âncora em
// `Pedido` (id_pedido), mostra os dados operacionais e o histórico das ações do
// operador. Reaproveitado pelo HistoricoModal (só a lista).

export const ROTULO_TIPO_HISTORICO = {
  edicao: "Edição",
  marcador: "Marcadores",
  comprovante: "Comprovante",
  troca_transportadora: "Troca de transportadora",
  notfis: "NOTFIS",
  lote: "Lote de despacho",
};

export const rotuloTipoHistorico = (tipo) => ROTULO_TIPO_HISTORICO[tipo] || tipo || "-";

const fmtDataHora = (v) => {
  const m = v ? moment(v) : null;
  return m && m.isValid() ? m.format("DD/MM/YYYY HH:mm") : "-";
};

const fmtNum = (v, sufixo) => {
  if (v === null || v === undefined || v === "") return "-";
  const n = Number(v);
  if (!Number.isFinite(n)) return String(v);
  const texto = n.toLocaleString("pt-BR", { maximumFractionDigits: 3 });
  return sufixo ? `${texto} ${sufixo}` : texto;
};

const dimensoes = (p) => {
  const partes = [p.altura, p.largura, p.comprimento];
  if (partes.every((v) => v === null || v === undefined || v === "")) return "-";
  return `${partes.map((v) => fmtNum(v)).join(" × ")} cm`;
};

export const CAMPOS_RESUMO = [
  { chave: "codigoRastreio", rotulo: "Código de rastreio", valor: (p) => p.codigoRastreio || "-" },
  { chave: "qtdVolumes", rotulo: "Volumes", valor: (p) => fmtNum(p.qtdVolumes) },
  { chave: "peso", rotulo: "Peso", valor: (p) => fmtNum(p.peso, "kg") },
  { chave: "dimensoes", rotulo: "Dimensões (A × L × C)", valor: dimensoes },
  { chave: "contatoNome", rotulo: "Contato", valor: (p) => p.contatoNome || "-" },
  { chave: "contatoTelefone", rotulo: "Telefone", valor: (p) => p.contatoTelefone || "-" },
  { chave: "contatoEmail", rotulo: "E-mail", valor: (p) => p.contatoEmail || "-" },
  { chave: "observacao", rotulo: "Observação", valor: (p) => p.observacao || "-" },
];

export function DadosOperacionais({ pedido }) {
  if (!pedido) return <div className="pedidos__notas-estado">Sem dados operacionais informados.</div>;
  return (
    <dl className="pedidos__dados" aria-label="Dados operacionais">
      {CAMPOS_RESUMO.map((c) => (
        <div key={c.chave} className="pedidos__dado">
          <dt>{c.rotulo}</dt>
          <dd>{c.valor(pedido)}</dd>
        </div>
      ))}
    </dl>
  );
}

export function HistoricoLista({ historico, vazio = "Nenhuma ação registrada neste pedido." }) {
  const itens = Array.isArray(historico) ? historico : [];
  if (!itens.length) return <div className="pedidos__notas-estado">{vazio}</div>;
  return (
    <ul className="pedidos__historico" aria-label="Histórico do pedido">
      {itens.map((h) => (
        <li key={h.id} className="pedidos__historico-item">
          <span className={`pedidos__historico-tipo pedidos__historico-tipo--${h.tipo || "outro"}`}>{rotuloTipoHistorico(h.tipo)}</span>
          <span className="pedidos__historico-texto">{h.descricao || "-"}</span>
          <small className="pedidos__historico-meta">
            {fmtDataHora(h.creationTime)}
            {h.usuario ? ` · ${h.usuario}` : ""}
          </small>
        </li>
      ))}
    </ul>
  );
}

// Carrega /pedidos/detalhe; `versao` força recarga depois de uma ação.
export function useDetalhePedido(pedido, versao) {
  const [estado, setEstado] = useState({ carregando: true, erro: "", dados: null });

  useEffect(() => {
    let ativo = true;
    setEstado({ carregando: true, erro: "", dados: null });
    obterDetalhe(pedido)
      .then((d) => ativo && setEstado({ carregando: false, erro: "", dados: d }))
      .catch((e) => ativo && setEstado({ carregando: false, erro: mensagemErroPedido(e, "Não conseguimos carregar o detalhe do pedido."), dados: null }));
    return () => {
      ativo = false;
    };
  }, [pedido, versao]);

  return estado;
}

export default function DetalhePedido({ pedido, versao }) {
  const { carregando, erro, dados } = useDetalhePedido(pedido, versao);

  if (carregando) {
    return (
      <div className="pedidos__notas-estado">
        <Spinner size="sm" style={{ color: AUTOPILOT_COLORS.accent }} /> Carregando dados do pedido...
      </div>
    );
  }
  if (erro) return <div className="pedidos__notas-estado pedidos__notas-estado--erro">{erro}</div>;

  return (
    <div className="pedidos__detalhe-blocos">
      <section className="pedidos__bloco">
        <h5 className="pedidos__bloco-titulo">Dados operacionais</h5>
        <DadosOperacionais pedido={dados && dados.pedido} />
      </section>
      <section className="pedidos__bloco">
        <h5 className="pedidos__bloco-titulo">Histórico</h5>
        <HistoricoLista historico={dados && dados.historico} />
      </section>
    </div>
  );
}
